import { GETGT2000DATAFILTER_TYPES } from '../actions/getGT2000DataFilter'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETGT2000DATAFILTER_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer
